import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { BANNER_ALT, BANNER_SRC } from "../../lib/brand";
import { CmykBar, Crosshair, RulerStrip } from "../Marks";

export const Banner = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start start", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "16%"]);
  const opacity = useTransform(scrollYProgress, [0, 0.9], [1, 0.35]);

  return (
    <div id="top" ref={ref} data-testid="hero-banner" className="relative pt-[60px]">
      <motion.div style={{ y, opacity }} className="relative">
        <div className="relative overflow-hidden">
          <motion.img
            src={BANNER_SRC}
            alt={BANNER_ALT}
            width="2000"
            height="415"
            fetchPriority="high"
            className="block h-auto w-full select-none"
            initial={{ opacity: 0, scale: 1.04 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1.1, ease: [0.16, 1, 0.3, 1] }}
          />
          <div
            aria-hidden="true"
            className="pointer-events-none absolute inset-0 grain"
          />
        </div>
        <CmykBar />
      </motion.div>

      <div className="flex items-center justify-between gap-4 border-b border-[#2a2a2a] px-5 py-3 sm:px-8">
        <span className="label-mono shrink-0 text-neutral-500">
          EST. PRODUCTION ART · 30 YEARS
        </span>
        <RulerStrip className="hidden flex-1 sm:block" color="#2a2a2a" />
        <span className="hidden shrink-0 items-center gap-3 text-neutral-600 sm:flex">
          <Crosshair size={14} />
          <span className="label-mono">ART / PRODUCTION / MERCHANDISE</span>
        </span>
      </div>
    </div>
  );
};
